/**
 * Compute the minimum set of transactions to settle all debts.
 * Uses greedy matching: pair largest debtor with largest creditor.
 *
 * @param {Object} moneyByPlayer - { playerId: { playerId, player, total, ... } }
 * @returns {Array<{ payerId, payeeId, amount, payer, payee }>}
 */
export function computeSettleUpTransactions(moneyByPlayer) {
  const debtors = [] // owe money (negative total)
  const creditors = [] // are owed money (positive total)

  for (const entry of Object.values(moneyByPlayer)) {
    const rounded = Math.round(entry.total)
    if (rounded < 0) debtors.push({ ...entry, remaining: Math.abs(rounded) })
    else if (rounded > 0) creditors.push({ ...entry, remaining: rounded })
  }

  // Sort descending by remaining amount
  debtors.sort((a, b) => b.remaining - a.remaining)
  creditors.sort((a, b) => b.remaining - a.remaining)

  const transactions = []
  let d = 0
  let c = 0

  while (d < debtors.length && c < creditors.length) {
    const amount = Math.min(debtors[d].remaining, creditors[c].remaining)
    if (amount > 0) {
      transactions.push({
        payerId: debtors[d].playerId,
        payeeId: creditors[c].playerId,
        amount,
        payer: debtors[d].player,
        payee: creditors[c].player,
      })
    }
    debtors[d].remaining -= amount
    creditors[c].remaining -= amount
    if (debtors[d].remaining === 0) d++
    if (creditors[c].remaining === 0) c++
  }

  return transactions
}
